import { baseUrlApis } from 'Api/index';
import {getQueryVariable, /* isPdfOnlineDomain, */ isDemo4Domain} from 'Utils/utils'
import {AiPluginController} from '../AIPlugin/index.js'
export function onDragAiPanel() {
  const doc = document;
  const aiPanel = doc.querySelector('.ai-panel');
  const dragBar = aiPanel.querySelector('.drag-bar');
  const mask = aiPanel.querySelector('.mask');
  const iframe = aiPanel.querySelector('iframe');
  const reloadBtn = aiPanel.querySelector('.ai-reload-btn');
  const closeBtn = aiPanel.querySelector('.close-btn');
  const noNetwork = aiPanel.querySelector('.no-network');
  //const contentDoc = iframe.contentDocument || {};

  let aiPanelWidth;
  let dragBarClientX;
  noNetwork.style.display = 'none';
  iframe.style.display = 'block';

  if (/* isPdfOnlineDomain() || */ isDemo4Domain()) {
    window.pdfui.getComponentByName('create-redactions-ribbon-inner-dropdown').then(component => {
      component && component.prepend(
        `<dropdown-button class="fv__ui-redaction-item"
        name="create-auto-redaction"  icon-class="fv__icon-toolbar-auto-redaction" @tooltip>
        @text
        </dropdown-button>`, [{
          target: 'create-auto-redaction',
          config: {
            text: 'redaction:buttons.redact_auto',
            tooltip: {
              title: 'redaction:tooltips.auto_redaction',
            },
            callback: () => {
              showAiPanel()
            } 
          }
        }]
      )
    })
  }

  // return;
  reloadBtn && reloadBtn.addEventListener('click', function () {
    // noNetwork.style.display = 'none';
    // iframe.style.display = 'block';
    isShowNetworkError()
    //iframe.contentWindow.location.reload();
  });

  closeBtn && closeBtn.addEventListener('click', function () {
    aiPanel.style.display = 'none';
    let debug = getQueryVariable('debug');
    let ai_plugin = getQueryVariable('ai_plugin');
    if('vconsole' === debug || ai_plugin === 'local'){
      AiPluginController.releaseAiPlugin();
    }
  });

  iframe.addEventListener('load', function () {
    //const docTitle = contentDoc.title;

    // if (docTitle !== 'Ai') {
    //     iframe.style.display = 'none';
    //     noNetwork.style.display = 'block';
    // }
  });

  dragBar && dragBar.addEventListener('mousedown', function (e) {
    aiPanelWidth = aiPanel.offsetWidth;
    dragBarClientX = e.clientX;

    mask.style.display = 'block';
    doc.addEventListener('mousemove', mousemoveListener);
    doc.addEventListener('mouseup', mouseupListener);
  });

  function mouseupListener() {
    mask.style.display = 'none';
    window.pdfui.redraw();

    doc.removeEventListener('mousemove', mousemoveListener);
    doc.removeEventListener('mouseup', mouseupListener);
  }

  function mousemoveListener(e) {
    const dis = dragBarClientX - e.clientX;
    const newWidth = dis + aiPanelWidth;

    if (newWidth > 380) {
      aiPanel.style.width = `${newWidth}px`;
    }
  }
}
export async function showAiPanel() {
  let rightPanel = await pdfui.getComponentByName('sidebar-right');
  let tabs = await pdfui.getComponentByName('sidebar-right-tabs');
  rightPanel.show();
  tabs.openTab('foxit-ai-panel');
  tabs.setActivetab('foxit-ai-panel')
  // if (tabs.activetab === 'foxit-ai-panel' && rightPanel.isExpand) {
  //     tabs.closeTab('right-search-panel');
  //     store.state.searchType = '';
  // } else {
  // }

  AiPluginController.init()
  const doc = document;
  const aiPanel = doc.querySelector('.ai-panel');

  isShowNetworkError();

  aiPanel.style.display = 'flex';
}

async function isShowNetworkError() {
  const doc = document;
  const aiPanel = doc.querySelector('.ai-panel');
  const iframe = aiPanel.querySelector('iframe');
  const noNetwork = aiPanel.querySelector('.no-network');

  try {
    const result = await baseUrlApis.checkAiPluginNetWork();

    iframe.style.display = 'block';
    noNetwork.style.display = 'none';
    return result;
  } catch (error) {
    iframe.style.display = 'none';
    noNetwork.style.display = 'block';
  }
}
